/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetSuiteCredentials } from "./NetSuiteCredentials";
import {
  NetSuiteCredentialsFromJSON,
  NetSuiteCredentialsFromJSONTyped,
  NetSuiteCredentialsToJSON,
  NetSuiteCredentialsToJSONTyped,
} from "./NetSuiteCredentials";
import type { IntegrationEnvironment } from "./IntegrationEnvironment";
import {
  IntegrationEnvironmentFromJSON,
  IntegrationEnvironmentFromJSONTyped,
  IntegrationEnvironmentToJSON,
  IntegrationEnvironmentToJSONTyped,
} from "./IntegrationEnvironment";

/**
 *
 * @export
 * @interface CreateNetSuiteIntegrationRequest
 */
export interface CreateNetSuiteIntegrationRequest {
  /**
   *
   * @type {string}
   * @memberof CreateNetSuiteIntegrationRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CreateNetSuiteIntegrationRequest
   */
  name: string;
  /**
   *
   * @type {IntegrationEnvironment}
   * @memberof CreateNetSuiteIntegrationRequest
   */
  environment: IntegrationEnvironment;
  /**
   *
   * @type {boolean}
   * @memberof CreateNetSuiteIntegrationRequest
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateNetSuiteIntegrationRequest
   */
  accountId: string;
  /**
   *
   * @type {NetSuiteCredentials}
   * @memberof CreateNetSuiteIntegrationRequest
   */
  credentials: NetSuiteCredentials;
}

/**
 * Check if a given object implements the CreateNetSuiteIntegrationRequest interface.
 */
export function instanceOfCreateNetSuiteIntegrationRequest(
  value: object,
): value is CreateNetSuiteIntegrationRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("environment" in value) || value["environment"] === undefined)
    return false;
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  if (!("accountId" in value) || value["accountId"] === undefined) return false;
  if (!("credentials" in value) || value["credentials"] === undefined)
    return false;
  return true;
}

export function CreateNetSuiteIntegrationRequestFromJSON(
  json: any,
): CreateNetSuiteIntegrationRequest {
  return CreateNetSuiteIntegrationRequestFromJSONTyped(json, false);
}

export function CreateNetSuiteIntegrationRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateNetSuiteIntegrationRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    name: json["name"],
    environment: IntegrationEnvironmentFromJSON(json["environment"]),
    enabled: json["enabled"],
    accountId: json["accountId"],
    credentials: NetSuiteCredentialsFromJSON(json["credentials"]),
  };
}

export function CreateNetSuiteIntegrationRequestToJSON(
  json: any,
): CreateNetSuiteIntegrationRequest {
  return CreateNetSuiteIntegrationRequestToJSONTyped(json, false);
}

export function CreateNetSuiteIntegrationRequestToJSONTyped(
  value?: CreateNetSuiteIntegrationRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    name: value["name"],
    environment: IntegrationEnvironmentToJSON(value["environment"]),
    enabled: value["enabled"],
    accountId: value["accountId"],
    credentials: NetSuiteCredentialsToJSON(value["credentials"]),
  };
}
